/** Languages of the portal; Arabic is written right to left. */
export const BRAND_LOCALES = ['fr', 'ar', 'en'];
export const RTL_BRAND_LOCALES = ['ar'];
/** Each language under its own name, in the language pickers of the portal and of Keycloak. */
export const LANGUAGE_NAMES = {
    fr: 'Français',
    ar: 'العربية',
    en: 'English',
};
export const brandCopy = {
    fr: {
        name: 'Gestion des déchets',
        tagline: 'Traçabilité & conformité',
        headline: 'La traçabilité de vos déchets, conforme à la réglementation marocaine.',
        lead: 'Du catalogue des déchets au registre, un seul outil pour le responsable déchets, le site et le groupe.',
        points: [
            'Déchets codés sur le Catalogue Marocain des Déchets, mentions ADR calculées',
            'CAP, autorisations des prestataires et échéances sous contrôle',
            'Bordereaux de suivi, registre et rapport annuel sans ressaisie',
            'Données hébergées au Maroc',
        ],
        footer: 'Loi 28-00 · Décret 2-14-85 · Loi 30-05',
    },
    ar: {
        name: 'تدبير النفايات',
        tagline: 'التتبع والمطابقة',
        headline: 'تتبع نفاياتكم وفق التنظيم المغربي.',
        lead: 'من دليل النفايات إلى السجل، أداة واحدة لمسؤول النفايات والموقع والمجموعة.',
        points: [
            'نفايات مرمزة وفق الدليل المغربي للنفايات وبيانات ADR محتسبة',
            'شهادات القبول ورخص مقدمي الخدمات والآجال تحت المراقبة',
            'بيانات التتبع والسجل والتقرير السنوي دون إعادة إدخال',
            'بيانات مستضافة في المغرب',
        ],
        footer: 'القانون 28-00 · المرسوم 2-14-85 · القانون 30-05',
    },
    en: {
        name: 'Waste management',
        tagline: 'Traceability & compliance',
        headline: 'Waste traceability that complies with Moroccan regulations.',
        lead: 'From the waste catalogue to the register, one tool for the waste manager, the site and the group.',
        points: [
            'Wastes coded on the Moroccan Waste Catalogue, ADR descriptions computed',
            'CAPs, provider authorisations and deadlines under control',
            'Tracking forms, register and annual report without re-keying',
            'Data hosted in Morocco',
        ],
        footer: 'Law 28-00 · Decree 2-14-85 · Law 30-05',
    },
};
//# sourceMappingURL=copy.js.map